/**
 * SV-563: readable (non-HttpOnly) companion to the HttpOnly `tms_access_token` cookie.
 *
 * Set and cleared together with the access-token cookie, with the same lifetime, so its
 * presence means "the access cookie still exists" and its value (epoch seconds) is when
 * both expire. Lets the SPAs schedule token refresh without a network call.
 *
 * Not a credential: the server never reads it or uses it for authorization.
 */
export const AUTH_SESSION_EXP_COOKIE = 'tms_session_exp';
